import cleanCss from 'helpers/cleanCss';
import getViewPort from 'helpers/getViewPort';
import sortStyles from 'helpers/sortStyles';
import loadSingleFont from 'helpers/loadSingleFont';

if (!window.disableCache) {
  window.hashMemorySetCssMediaQuery = new Map();
}

export default function setCssMediaQuery(thatStyle, typeOfStyle, viewPort, thisWindow, autoMerge) {
  
  if (!thatStyle || typeof thatStyle !== 'object') return '';

  let setHashKey;
  if (!window.disableCache) {
    setHashKey = JSON.stringify(thatStyle)+typeOfStyle+viewPort+autoMerge;

    const getHash = window.hashMemorySetCssMediaQuery.get(setHashKey);
  
    if (getHash || getHash === '') return getHash;
  }

  let thisCss = '';
  const thisStyles = thatStyle[typeOfStyle];
  const thisStylesHover = thatStyle[`${typeOfStyle}_hover`];

  if (!thatStyle) return thisCss;
  

  const setViewPort = getViewPort(viewPort);

  const sortedStyles = sortStyles(thisStyles, !viewPort, autoMerge);

  const sortedStylesHover = sortStyles(thisStylesHover, !viewPort, autoMerge);

  if (sortedStyles) {
    for (let i = 0; i < sortedStyles.length; i++) {
   
      const contentKey = sortedStyles[i].replace('_', '.');

      const contentValue = thisStyles[sortedStyles[i]];
      if (contentValue && contentValue['font-family']) {
        const thisLoadedFont = loadSingleFont(contentValue['font-family'], null, thisWindow);
        if (!sortedStyles['font-weight'] && thisLoadedFont) {
          thisCss += `
            font-weight: ${thisLoadedFont};     
          `;
        }
      }
      if (setViewPort && (Number(setViewPort) <= Number(contentKey) && setViewPort !== '0') || contentKey === '0') {
        thisCss += `
          ${cleanCss(contentValue)}
        `;
      }
      if (!setViewPort && contentKey !== '0' || autoMerge) {
        thisCss += `
          @media (max-width: ${contentKey}em) {
            ${cleanCss(contentValue)}
          }
          ${autoMerge ? cleanCss(contentValue) : ''}
        `;
      }

    }

  }

  if (sortedStylesHover) {

    for (let i = 0; i < sortedStylesHover.length; i++) {

      const contentKey = sortedStylesHover[i].replace('_', '.');

      const contentValue = thisStylesHover[sortedStylesHover[i]];
      let extraStyles = '';
      if (contentValue && contentValue['font-family']) {
        const thisLoadedFont = loadSingleFont(contentValue['font-family'], null, thisWindow);
        if (!sortedStyles['font-weight'] && thisLoadedFont) {
          extraStyles += `
              font-weight: ${thisLoadedFont};      
          `;
        }
      }

      if (setViewPort && (Number(setViewPort) <= Number(contentKey) && setViewPort !== '0') || contentKey === '0') {
        thisCss += `
          &:hover {
            ${extraStyles}
            ${cleanCss(contentValue)}
          }
        `;
      }

      if (!setViewPort && contentKey !== '0' || autoMerge) {
        thisCss += `
          @media (max-width: ${contentKey}em) {
            &:hover {
              ${extraStyles}
              ${cleanCss(contentValue)}
            }

            ${autoMerge ? `&:hover {
              ${extraStyles}
              ${cleanCss(contentValue)}
            }` : ''}
          }
        `;
      }

    }
  }

  const thisCssContent = thisCss.replace(/\s\s+/g, ' ');

  if (setHashKey) window.hashMemorySetCssMediaQuery.set(setHashKey, thisCssContent);
  return thisCssContent;
}
